import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world4_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2842,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world4_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5406,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world4_3",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8110,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world4_4",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 368,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 465,
      y: 477,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 545,
      y: 527,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 636,
      y: 564,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 733,
      y: 562,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "15",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 803,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 832,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "17",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 872,
      y: 333,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "18",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 958,
      y: 295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1052,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "20",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1121,
      y: 379,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1188,
      y: 444,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1268,
      y: 502,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "23",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1362,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1464,
      y: 530,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "25",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1564,
      y: 504,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "26",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1652,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "27",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1723,
      y: 392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "28",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1797,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1885,
      y: 288,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "30",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1986,
      y: 279,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "31",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2080,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "32",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2155,
      y: 366,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "33",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2217,
      y: 431,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "34",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2289,
      y: 494,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "35",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2368,
      y: 546,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "36",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2456,
      y: 585,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2551,
      y: 610,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2642,
      y: 619,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2734,
      y: 622,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "40",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2831,
      y: 620,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2919,
      y: 592,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3008,
      y: 546,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3107,
      y: 514,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3206,
      y: 508,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "45",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3306,
      y: 523,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3406,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "47",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3507,
      y: 503,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "48",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3562,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "49",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3626,
      y: 352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3719,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3815,
      y: 268,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "52",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3916,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "53",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4003,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "54",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4074,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4152,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4240,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4336,
      y: 566,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4437,
      y: 575,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4541,
      y: 566,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4644,
      y: 539,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4720,
      y: 486,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4784,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "63",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4848,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4917,
      y: 294,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "65",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4993,
      y: 239,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "66",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5086,
      y: 200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "67",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5187,
      y: 183,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "68",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5294,
      y: 183,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "69",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5390,
      y: 190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5486,
      y: 220,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "71",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5566,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "72",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5626,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "73",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5677,
      y: 411,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5728,
      y: 483,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "75",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5798,
      y: 541,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "76",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5885,
      y: 578,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "77",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5977,
      y: 582,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "78",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6072,
      y: 560,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "79",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6157,
      y: 520,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6237,
      y: 476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6313,
      y: 430,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "82",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6397,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6489,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6584,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6678,
      y: 393,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "86",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6765,
      y: 433,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6852,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "88",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6940,
      y: 505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "89",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7035,
      y: 518,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "90",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7126,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "91",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7214,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7308,
      y: 437,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7404,
      y: 437,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "94",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7497,
      y: 474,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "95",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7574,
      y: 527,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7652,
      y: 578,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "97",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7745,
      y: 618,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "98",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7841,
      y: 634,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "99",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7939,
      y: 634,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "100",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8032,
      y: 598,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "101",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8103,
      y: 537,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "102",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8172,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "103",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8254,
      y: 424,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "104",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8343,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "105",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8440,
      y: 364,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "106",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8537,
      y: 354,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8636,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8726,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8811,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "110",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8894,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "111",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8993,
      y: 526,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "112",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9086,
      y: 557,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "113",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9188,
      y: 575,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "114",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9292,
      y: 569,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "115",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9381,
      y: 517,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "116",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9449,
      y: 441,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "117",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9507,
      y: 365,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "118",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9585,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "119",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9688,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "120",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9787,
      y: 260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "121",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9882,
      y: 276,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "122",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9970,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "123",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10045,
      y: 358,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "124",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10111,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "125",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10172,
      y: 504,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "126",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10248,
      y: 567,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "127",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10349,
      y: 589,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "128",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10449,
      y: 562,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "129",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10536,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "130",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "169",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "203",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "234",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "269",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "284",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "297",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "315",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "165",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "199",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "230",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "265",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "280",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "293",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "311",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "331",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "131",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1349,
      y: 78,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "132",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1479,
      y: 93,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "133",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1636,
      y: 99,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "134",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1238,
      y: 117,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "135",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1777,
      y: 137,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "136",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1127,
      y: 164,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "137",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1330,
      y: 172,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "138",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1505,
      y: 200,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "139",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1678,
      y: 217,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "140",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1386,
      y: 251,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "141",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1558,
      y: 256,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "142",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1233,
      y: 258,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "143",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1618,
      y: 315,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "144",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1451,
      y: 320,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "145",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 609,
      y: 341,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "146",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1315,
      y: 348,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "147",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 555,
      y: 433,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "148",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 669,
      y: 467,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "149",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1034,
      y: 561,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "150",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 959,
      y: 630,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "151",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 391,
      y: 631,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "152",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1088,
      y: 670,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "153",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 228,
      y: 688,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "154",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 471,
      y: 705,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "155",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 862,
      y: 705,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "156",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 341,
      y: 719,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "157",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 997,
      y: 734,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "158",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1159,
      y: 764,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "159",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 537,
      y: 767,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "130",
      data: ""
    },
    {
      id: "160",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 427,
      y: 792,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "161",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 931,
      y: 807,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "162",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 608,
      y: 832,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1100,
      y: 837,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "164",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 797,
      y: 850,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "130",
      data: ""
    },
    {
      id: "170",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2489,
      y: 76,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "171",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2350,
      y: 103,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "172",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2242,
      y: 104,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "173",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2538,
      y: 177,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "174",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2172,
      y: 188,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "175",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2326,
      y: 203,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "176",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2440,
      y: 234,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "177",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2533,
      y: 296,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "178",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2290,
      y: 298,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "179",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2388,
      y: 336,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "180",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2463,
      y: 408,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "181",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2586,
      y: 429,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "182",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1960,
      y: 549,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "183",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2083,
      y: 623,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "184",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1818,
      y: 658,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "185",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1945,
      y: 666,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "186",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2194,
      y: 704,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "187",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2055,
      y: 727,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "188",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1693,
      y: 738,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "189",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1896,
      y: 746,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "190",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2306,
      y: 783,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "191",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1785,
      y: 797,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "192",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2146,
      y: 811,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "193",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1988,
      y: 824,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "194",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2435,
      y: 839,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_4",
      parent: "169",
      data: ""
    },
    {
      id: "195",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2253,
      y: 155,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "169",
      data: ""
    },
    {
      id: "196",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2424,
      y: 156,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "169",
      data: ""
    },
    {
      id: "197",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2553,
      y: 359,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "169",
      data: ""
    },
    {
      id: "198",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1642,
      y: 805,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_1",
      parent: "169",
      data: ""
    },
    {
      id: "204",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2880,
      y: 440,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "205",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2870,
      y: 340,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "206",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2860,
      y: 240,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "207",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2830,
      y: 120,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "208",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3010,
      y: 390,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "209",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3020,
      y: 300,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "210",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2980,
      y: 190,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "211",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2990,
      y: 75,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "212",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3170,
      y: 380,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "213",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3165,
      y: 260,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "214",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3130,
      y: 140,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "215",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3320,
      y: 330,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "216",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3280,
      y: 200,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "217",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3420,
      y: 260,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "218",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3400,
      y: 150,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "219",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3260,
      y: 100,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "220",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3120,
      y: 40,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "221",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3380,
      y: 45,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "222",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3010,
      y: 770,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3090,
      y: 700,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "224",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3210,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "225",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3140,
      y: 785,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "226",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3340,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "227",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3275,
      y: 775,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "228",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3460,
      y: 730,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "229",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3395,
      y: 820,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "203",
      data: ""
    },
    {
      id: "235",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4210,
      y: 190,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "236",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4330,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "237",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4250,
      y: 300,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "238",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4370,
      y: 200,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "239",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4500,
      y: 80,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "240",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4350,
      y: 390,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "241",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4450,
      y: 290,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "242",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4560,
      y: 190,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "243",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4680,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "244",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4510,
      y: 380,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "245",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4610,
      y: 280,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "246",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4730,
      y: 180,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "247",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4850,
      y: 80,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "248",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4150,
      y: 740,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "249",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4090,
      y: 800,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "250",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4310,
      y: 810,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "251",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4500,
      y: 840,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "252",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4690,
      y: 790,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "253",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4850,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "254",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5000,
      y: 580,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "255",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5110,
      y: 470,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "256",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4860,
      y: 820,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "257",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5030,
      y: 700,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "258",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5150,
      y: 580,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "259",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5260,
      y: 445,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "260",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5310,
      y: 555,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "261",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5200,
      y: 680,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "262",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5100,
      y: 790,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "263",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5280,
      y: 770,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "264",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5360,
      y: 670,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_3",
      parent: "234",
      data: ""
    },
    {
      id: "270",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5570,
      y: 717,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "271",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5800,
      y: 888,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "272",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6035,
      y: 980,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "273",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6250,
      y: 860,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "274",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6500,
      y: 740,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "275",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6690,
      y: 960,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "276",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5760,
      y: 155,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "277",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5970,
      y: 93,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "278",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5950,
      y: 382,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "279",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6195,
      y: 212,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "269",
      data: ""
    },
    {
      id: "285",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7135,
      y: 830,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "286",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7385,
      y: 750,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "287",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7600,
      y: 900,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "288",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7350,
      y: 230,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "289",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7592,
      y: 300,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "290",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7790,
      y: 120,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "291",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7830,
      y: 390,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "292",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8050,
      y: 272,
      anchor: {
        x: 0.51,
        y: 0.82
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_4",
      parent: "284",
      data: ""
    },
    {
      id: "298",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8260,
      y: 170,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "299",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8415,
      y: 240,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "300",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8520,
      y: 110,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "301",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8650,
      y: 260,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "302",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8780,
      y: 140,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "303",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8880,
      y: 310,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "304",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8300,
      y: 860,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "305",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8500,
      y: 870,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "306",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8700,
      y: 860,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "307",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8400,
      y: 710,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "308",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8600,
      y: 680,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "309",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8800,
      y: 750,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "310",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8900,
      y: 880,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "297",
      data: ""
    },
    {
      id: "316",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9480,
      y: 780,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "317",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9730,
      y: 760,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "318",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9980,
      y: 740,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "319",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9605,
      y: 860,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "320",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9855,
      y: 840,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "321",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9625,
      y: 660,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "322",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9875,
      y: 640,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "323",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9760,
      y: 560,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "324",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9340,
      y: 110,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "325",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9575,
      y: 200,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "326",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9480,
      y: 80,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "327",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9745,
      y: 160,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "328",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9905,
      y: 110,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "329",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10035,
      y: 240,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "330",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10150,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplants_4",
      parent: "315",
      data: ""
    },
    {
      id: "166",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1053,
      y: 607,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "165",
      data: ""
    },
    {
      id: "200",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1990,
      y: 550,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "199",
      data: ""
    },
    {
      id: "231",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3345,
      y: 180,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "230",
      data: ""
    },
    {
      id: "266",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4460,
      y: 217,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "265",
      data: ""
    },
    {
      id: "281",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6171,
      y: 660,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "280",
      data: ""
    },
    {
      id: "294",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7403,
      y: 617,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "293",
      data: ""
    },
    {
      id: "312",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8550,
      y: 110,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "311",
      data: ""
    },
    {
      id: "332",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9830,
      y: 620,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "331",
      data: ""
    },
    {
      id: "167",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "166",
      data: ""
    },
    {
      id: "168",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_harvest_map",
      parent: "166",
      data: ""
    },
    {
      id: "201",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "200",
      data: ""
    },
    {
      id: "202",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "onion_harvest_map",
      parent: "200",
      data: ""
    },
    {
      id: "232",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "231",
      data: ""
    },
    {
      id: "233",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_harvest_map",
      parent: "231",
      data: ""
    },
    {
      id: "267",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "266",
      data: ""
    },
    {
      id: "268",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cabbage_harvest_map",
      parent: "266",
      data: ""
    },
    {
      id: "282",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "281",
      data: ""
    },
    {
      id: "283",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_harvest_map",
      parent: "281",
      data: ""
    },
    {
      id: "295",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "294",
      data: ""
    },
    {
      id: "296",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "olive_harvest_map",
      parent: "294",
      data: ""
    },
    {
      id: "313",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "312",
      data: ""
    },
    {
      id: "314",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplant_harvest_map",
      parent: "312",
      data: ""
    },
    {
      id: "333",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "332",
      data: ""
    },
    {
      id: "334",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "eggplant_harvest_map",
      parent: "332",
      data: ""
    }
  ]
} as const;

export class WorldLayout4 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
